<template>
  <el-dialog
    title="数据升级包新增窗口"
    :visible.sync="visible"
    width="800px"
    @close="close">

    <el-form :inline="true" :model="DataUpgradeInsertForm" label-position="right">
      <el-form-item label="观测号">
        <el-autocomplete
            class="inline-input"
            style="width:240px;"
            v-model="DataUpgradeInsertForm.obs_id"
            :fetch-suggestions="querySearch"
            :placeholder="`${$t('proposal.obs_id')}`"
            :trigger-on-focus="false"
            @select="handleSelect"
            clearable>
          </el-autocomplete>
      </el-form-item>
      <el-form-item label="数据级别">
        <el-select  v-model="DataUpgradeInsertForm.level" style="width:230px;" filterable placeholder="1L/1.5L/2L..." clearable>
          <el-option
              v-for="item in datalevel"
              :key="item.value"
              :label="item.label"
              :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="数据版本">
        <el-input v-model="DataUpgradeInsertForm.file_ver" autocomplete="off" style="width:230px;"></el-input>
      </el-form-item>
      <el-form-item label="生成时间">
        <el-date-picker v-model="DataUpgradeInsertForm.archive_time" value-format="yyyy-MM-dd HH:mm:ss" format="yyyy-MM-dd HH:mm:ss" type="datetime" style="width:230px;"></el-date-picker>
      </el-form-item>
      <el-form-item label="升级包文件">
        <el-input v-model="DataUpgradeInsertForm.file_path" autocomplete="off" style="width:525px;"></el-input>
      </el-form-item>

      


      
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="close">取消</el-button>
      <el-button type="primary" @click="ok">确定</el-button>
    </div>

  </el-dialog>
</template>

<script>
import {PropDataLevel} from '../common';
export default {
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    dialogData: {
      type: Array,
      default(){
        return [];
      },
    },
  },
  data() {
    return {
      DataUpgradeInsertForm:{
        id:'', 
        obs_id:'', 
        level:'', 
        file_ver:'',
        archive_time:'',
        file_path:'',
      },
      restaurants: [],
      datalevel:PropDataLevel,
      visible: false,
    };
  },
  watch: {
    dialogVisible(val) {
      // console.log("dialogVisible传入数据在这里",val);
      this.visible = val;
    },
    dialogData(data){
      // console.log("coreedit传入数据在这里",data);
      this.restaurants = data;
    },
  },
  methods: {
    close() {
      this.$emit('close');
    },
    ok() {
      this.$emit('ok', {
        ...this.DataUpgradeInsertForm,
      });
    },
    querySearch(queryString, cb) {
        var restaurants = this.restaurants;
        var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
        // 调用 callback 返回建议列表的数据
        cb(results);
    },
    handleSelect(item) {
        if(item){
          this.searchParams.fileID = '';
          this.searchParams.file_path = '';
          this.getfielinfo(item.value);
        }
    },
    createFilter(queryString) {
        return (restaurant) => {
          return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) >= 0);
        };
    },
  }
}
</script>

<style lang="scss" scoped>

</style>
